import React from 'react';
import RHSearchResult from '@components/search/search-result/rh-search-result';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { useInfiniteHits } from 'react-instantsearch';
import { ResultsBlockProps } from './results-block.types';

const ResultsBlock: React.FC<ResultsBlockProps> = ({ className }) => {
  const { hits, results, isLastPage, showMore } = useInfiniteHits();

  const totalResults = results?.nbHits ?? 0;
  const displayedResults = hits.length;

  return (
    <div className={className} role="main">
      <div className="ais-InfiniteHits">
        <ol className="ais-InfiniteHits-list">
          {hits.map((hit: any) => (
            <li key={hit.objectID} className="ais-InfiniteHits-item">
              <RHSearchResult hit={hit} />
            </li>
          ))}
        </ol>

        {totalResults > 0 && (
          <div className="results-count">
            Showing {displayedResults} of {totalResults} results
          </div>
        )}

        {!isLastPage && (
          <button
            className="ais-InfiniteHits-loadMore"
            onClick={showMore}
            type="button"
          >
            {Translate('Load more', true)}
          </button>
        )}
      </div>
    </div>
  );
};

const StyledResultsBlock = styled(ResultsBlock)`
  .ais-InfiniteHits {
    margin-left: -${vars.spacingL};
    margin-right: -${vars.spacingL};

    .ais-InfiniteHits-list {
      width: 100%;
    }

    .ais-InfiniteHits-item {
      margin: 0;
      font-weight: ${vars.fontWeightRegular};
      width: 100%;

      a {
        width: 100%;
      }

      flex-grow: 1;
    }

    .results-count {
      margin-top: ${vars.spacingL};
      text-align: center;
      font-size: 1.2rem;
    }

    .ais-InfiniteHits-loadMore {
      display: block;
      margin: ${vars.spacingS} auto ${vars.spacingS} auto;
    }
  }
`;

export default StyledResultsBlock;
